<template>
  <b-navbar toggleable="lg" type="dark" variant="dark">
    <b-navbar-brand to="/"><img src="../assets/logo-horizontal.png" alt="Fleet Battle logo"></b-navbar-brand>
    
  </b-navbar>
</template>

<script>
export default {
  name: 'Topbar',
  data () {
    return {
      env: ''
    }
  },
  created () {
  },
  methods: {
  }
}
</script>


<style lang="scss">

.navbar-brand img {
  max-width: 250px;
}

nav.bg-dark {
  background-color: #001435 !important;
}

</style>
